<template>
  <v-container>
    <v-responsive
      class="mx-auto px-3 px-md-12"
      max-width="750"
    >
      <div
        class="text-center"
        width="100%"
      >
        <h1>Welcome to MES<sup>&reg;</sup>!</h1>
        <div>
          <img
            :src="require('@/assets/logo.png')"
            alt="Profile 2"
            class="bottom-image"
          >
        </div>
        <p>Thank you for signing up! We’re excited to have you join our community of producers and synth enthusiasts. As a member, you’ll receive the latest updates, exclusive access to new releases, and expert tips right in your inbox.</p>
        <div class="cta-buttons">
          <button
            style="width: 500px; height: 44px; text-transform: none;"
            class="cta-button download-button"
            @click="handleButtonClick('Buy')"
          >
            Buy Full Version of Annaliis
          </button>
        </div>
        <div class="cta-buttons">
          <button
            style="width: 500px; height: 44px; text-transform: none;"
            class="cta-button download-button"
            @click="handleButtonClick('Buy')"
          >
            Buy Full Version of MES Arpeggiator
          </button>
        </div>
        <h2>Get Started with a Download.</h2>
        <p>Explore our Instagram and YouTube channels for a wealth of tutorials, tips, and the latest news. Whether you're a beginner eager to learn the fundamentals of synthesis with Annaliis or an experienced synth user seeking innovative techniques, MES<sup>&reg;</sup> is dedicated to supporting your Colorfully Unique<sup>&reg;</sup> journey into sound.</p>
        <download-buttons />
      </div>
    </v-responsive>
  </v-container>
</template>

  <script>
  import DownloadButtons from './DownloadButtons.vue'

  export default {
    components: {
      DownloadButtons
    },
    methods: {
      handleButtonClick (buttonType) {
        this.$router.push({ name: 'Buy' })
      },
    },
  }
  </script>

  <style scoped>
  /* Optional: Add some CSS styles to make your welcome page pop */
  h1 {
    margin-top: 20px;
  }
  h2 {
    margin-top: 15px;
  }

  .bottom-image {
    max-width: 80px;
    height: auto;
    margin: 20px 0;
  }
  </style>
